/**
 * Stepped Select Options relating to the Get In Touch Form from asset #4539
 * used in https://www.gtlaw.com.au/contact-us. Form fields are shown/hidden depending on
 * the value selection from question "What does your enquiry relate to?"
 */

export default function steppedSelectOption() {
    const getInTouchForm = document.getElementById('form_email_4528');

    const enquirySelectOption = document.querySelector('#q4538_q1');
    const serviceAreaSelectOption = document.querySelector('#sq_form_field_wrapper_q4538_q2');
    const subjectText = document.querySelector('#sq_form_field_wrapper_q4538_q3');
    // Individual or Organisation
    const adviceSelectOption = document.querySelector('#sq_form_field_wrapper_q4538_q5');
    const proBonoCategory = document.querySelector('#sq_form_field_wrapper_q4538_q6');

    if (getInTouchForm && enquirySelectOption && serviceAreaSelectOption && subjectText && adviceSelectOption && proBonoCategory) {
        subjectText.style.display = 'block';
        serviceAreaSelectOption.style.display = 'none';
        adviceSelectOption.style.display = 'block';
        proBonoCategory.style.display = 'none';

        enquirySelectOption.addEventListener('change', function () {
            // Get the value of the selected option
            const selectedValue = this.value;

            // Show the appropriate input field based on the selected option
            if (selectedValue === 'Legal Services') {
                subjectText.style.display = 'block';
                serviceAreaSelectOption.style.display = 'block';
                proBonoCategory.style.display = 'none';
            } else if (selectedValue === 'Pro Bono') {
                subjectText.style.display = 'none';
                serviceAreaSelectOption.style.display = 'none';
                proBonoCategory.style.display = 'block';
            } else {
                subjectText.style.display = 'block';
                serviceAreaSelectOption.style.display = 'none';
                proBonoCategory.style.display = 'none';
            }
        });
    }
}
